<template>
  <aside class="alice-adminsub" aria-label="Admin navigation">
    <div class="alice-adminsub__head">
      <div class="alice-adminsub__eyebrow">
        <span class="alice-adminsub__eyebrow-mark" />
        <span>Workspace</span>
      </div>
      <h2 class="alice-adminsub__title">Admin</h2>
      <p class="alice-adminsub__lede">
        Internal controls. Be careful — these settings are global.
      </p>
    </div>

    <nav class="alice-adminsub__tabs">
      <router-link
        v-for="tab in tabs"
        :key="tab.key"
        :to="tab.to"
        class="alice-adminsub__tab"
        active-class="alice-adminsub__tab--active"
      >
        <span class="alice-adminsub__tab-label">{{ tab.label }}</span>
        <span v-if="tab.count != null" class="alice-adminsub__tab-count">{{
          tab.count
        }}</span>
      </router-link>
    </nav>

    <div class="alice-adminsub__footer">
      <div>God-mode area</div>
      <div>Changes apply instantly across all users.</div>
    </div>
  </aside>
</template>

<script>
export default {
  name: "AliceAdminSubSidebar",
  props: {
    tabs: {
      type: Array,
      default: () => [
        { key: "ai", label: "AI Finetuning", to: "/admin/ai" },
        {
          key: "starters",
          label: "Conversation Starters",
          to: "/admin/starters",
        },
        { key: "kennisbank", label: "Kennisbank", to: "/admin/kennisbank" },
        { key: "analytics", label: "Analytics", to: "/admin/analytics" },
        { key: "rulebooks", label: "Rulebooks", to: "/admin/rulebooks" },
        { key: "clients", label: "Clients", to: "/admin/clients" },
        { key: "guests", label: "Guests", to: "/admin/guests" },
      ],
    },
  },
};
</script>

<style scoped>
.alice-adminsub {
  width: 280px;
  flex-shrink: 0;
  background: var(--vp-white);
  border-right: 1px solid var(--border-hairline);
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.alice-adminsub__head {
  padding: 24px 24px 20px;
  border-bottom: 1px solid var(--border-hairline);
}
.alice-adminsub__eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  font-family: var(--font-ui);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--fg-3);
}
.alice-adminsub__eyebrow-mark {
  width: 8px;
  height: 8px;
  background: var(--accent-100);
  display: inline-block;
  flex-shrink: 0;
}
.alice-adminsub__title {
  margin: 0 0 8px;
  font-family: var(--font-display);
  font-size: 26px;
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.15;
  color: var(--vp-black);
}
.alice-adminsub__lede {
  margin: 0;
  font-family: var(--font-body);
  font-size: 13px;
  color: var(--fg-3);
  line-height: 1.45;
}

.alice-adminsub__tabs {
  display: flex;
  flex-direction: column;
  padding: 8px 0;
  flex: 1;
  overflow-y: auto;
}
.alice-adminsub__tab {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 24px;
  border-left: 3px solid transparent;
  font-family: var(--font-body);
  font-size: 15px;
  font-weight: 400;
  color: var(--fg-2);
  text-decoration: none;
  transition: background var(--dur-fast) var(--ease-hover),
    color var(--dur-fast) var(--ease-hover),
    transform var(--dur-press) var(--ease-out);
}
.alice-adminsub__tab:active {
  transform: scale(0.98);
}
.alice-adminsub__tab:hover {
  background: var(--bg-muted);
  color: var(--vp-black);
}
.alice-adminsub__tab--active,
.alice-adminsub__tab--active:hover {
  background: var(--vp-white);
  color: var(--vp-black);
  border-left-color: var(--vp-black);
  font-weight: 700;
}
.alice-adminsub__tab-count {
  font-family: var(--font-ui);
  font-size: 12px;
  font-weight: 600;
  color: var(--fg-3);
}
.alice-adminsub__tab--active .alice-adminsub__tab-count {
  color: var(--vp-black);
}

.alice-adminsub__footer {
  padding: 16px 24px 20px;
  border-top: 1px solid var(--border-hairline);
  font-family: var(--font-ui);
  font-size: 12px;
  color: var(--fg-3);
  line-height: 1.6;
}
</style>
